import { useState } from "react";
import { ArrowLeft, RefreshCw } from "lucide-react";
import { useInvestData } from "./useInvestData.js";
import { Overview } from "./Overview.jsx";
import { NetWorthView } from "./NetWorthView.jsx";
import { PortfolioView } from "./PortfolioView.jsx";
import { WatchlistView } from "./WatchlistView.jsx";
import { CalculatorView } from "./CalculatorView.jsx";

const TABS = [["overview", "Overview"], ["networth", "Net worth"], ["portfolio", "Portfolio"], ["watchlist", "Watchlist"], ["calc", "Calculator"]];

// The whole Invest screen. `profile` is the active profile, `update(fn)` replaces it, `fmt` formats the profile currency.
export default function InvestPage({ profile, update, country, fmt, toast, onBack, initialTab = "overview" }) {
  const [tab, setTab] = useState(initialTab);
  const D = useInvestData({ profile, update, toast, fmt, country });
  return (
    <div className="px-5 pt-8 pb-28">
      <div className="flex items-center gap-3 mb-5">
        {onBack && <button onClick={onBack} aria-label="Back" className="p-1 -ml-1"><ArrowLeft size={18} className="text-ivory-dim" /></button>}
        <h2 className="v-display text-xl font-semibold flex-1">Invest</h2>
        <button onClick={() => D.refresh(false)} disabled={D.refreshing} aria-label="Refresh prices" className="p-1.5 disabled:opacity-40"><RefreshCw size={15} className={`text-ivory-dim ${D.refreshing ? "animate-spin" : ""}`} /></button>
      </div>
      <div role="tablist" aria-label="Invest sections" className="grid grid-cols-5 gap-1 mb-5">
        {TABS.map(([id, label]) => (
          <button key={id} role="tab" aria-selected={tab === id} onClick={() => setTab(id)} className="rounded-lg py-2 text-xs font-medium px-0.5"
            style={{ background: tab === id ? "var(--brass)" : "var(--card)", color: tab === id ? "var(--ink)" : "var(--ivory-dim)" }}>{label}</button>
        ))}
      </div>
      {tab === "overview" && <Overview D={D} go={setTab} />}
      {tab === "networth" && <NetWorthView D={D} />}
      {tab === "portfolio" && <PortfolioView D={D} />}
      {tab === "watchlist" && <WatchlistView D={D} />}
      {tab === "calc" && <CalculatorView D={D} go={setTab} />}
    </div>
  );
}
